import { useState } from 'react';
import styled from 'styled-components';

import { Flex, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import { useModalContext } from '@/components/Modal/Modal';
import Heading from '@/components/Typography/Heading';
import { modalStyle } from '@/styles/style';

import InboundImportOptions from '../../components/InboundImportOptions';
import type { ImportRuleT, ImportTemplateT } from '../types/types';

type Props = {
  importRule: ImportRuleT;
  loading: boolean;
  template: ImportTemplateT;
  confirmOptions: {
    label: string;
    callback: (i: ImportRuleT) => void;
  };
};

const IntercomImportSettingModal = (props: Props) => {
  const { closeModal } = useModalContext();
  const [importRule, setImportRule] = useState<ImportRuleT>(props.importRule);

  return (
    <Style g={40}>
      <Heading type="h2">Import options</Heading>
      <InboundImportOptions
        importRule={importRule}
        setImportRule={setImportRule}
        template={props.template}
      />
      <Flex j="flex-end">
        <Button
          sizeType="m"
          variant="ghost"
          onClick={() => {
            closeModal();
          }}
        >
          Cancel
        </Button>
        <Button
          sizeType="m"
          isLoading={props.loading}
          onClick={() => props.confirmOptions.callback(importRule)}
        >
          {props.confirmOptions.label}
        </Button>
      </Flex>
    </Style>
  );
};

const Style = styled(VFlex)`
  width: 600px;
  padding: 32px;
  ${modalStyle};
`;

export default IntercomImportSettingModal;
